class PromiseUtils {

    static isPromise(value){
        return value && value.then && typeof value.then === 'function';
    }

}

export default PromiseUtils;